import React from "react";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function CompaniesAutocompleteAsync({
  onSelect,
  value,
  variant = "outlined",
}) {
  const [open, setOpen] = React.useState(false);
  const [companies, setCompanies] = React.useState([]);
  const loading = open && companies.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const companiesRequest = await axios.get("/wp-json/api/v2/companies");
      if (active) {
        setCompanies(companiesRequest.data);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  return (
    <Autocomplete
      id="asynchronous-companies"
      style={{ width: 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) => option.name === value.name}
      getOptionLabel={(option) => option.name}
      options={companies}
      value={
        value && Object.keys(value).length
          ? companies.filter((item) => item.id === value.id)[0]
          : null
      }
      loading={loading}
      onChange={(e, value) => {
        onSelect(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Company Name"
          variant={variant}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
